/**
 * Make whole wrapper clickable while maintaining accessible DOM. Accessibility helper functionality.
 * Can be used on any element.
 *
 * Required elements for functionality:
 * <div class="js-link-wrapper">
 *  ...
 * <a href="/url/" data-link-wrapper-target>...</a>
 *  ...
 * </div>
 * 
 * Usefull styling classes for elements inside the wrapper (optional, for hover styling):
 * <span class="link-wrapper__link-appearance">...</span> - link styling
 * <div class="link-wrapper__image"><img/></div> - image hover effects, if any
 * */

export default class LinkWrappers { 

  constructor() {
    this.linkWrappers = document.querySelectorAll('.js-link-wrapper');
    this.linkSelector = '[data-link-wrapper-target]'; //selector for link we want to use
    this.classForReady = 'link-wrapper'; //class that is given to wrapper after init

    //bound event functions to this, so we are able to use selectors
    this._onBlur = this._onBlur.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onFocus = this._onFocus.bind(this);
  }

  /**
   * Attach click event listeners to link area
   */
  attachListeners() {
    this.linkWrappers.forEach((wrapper) => {
      const link = wrapper.querySelector(this.linkSelector);
      if (link && link.href) {
        wrapper.classList.add(this.classForReady);
        wrapper.addEventListener('click', this._onClick, false);
        link.addEventListener('focus', this._onFocus);
        link.addEventListener('blur', this._onBlur);
      }
    });
  }

  /**
   * Update listeners after content change
   * Call this if you have loaded new wrappers to the page
   */
  update() {
    this._removeListeners();
    this.linkWrappers = document.querySelectorAll('.js-link-wrapper');
    this.attachListeners();
  }

  /**
   * Removes old event listeners
   */
  _removeListeners() {
    this.linkWrappers.forEach((wrapper) => {
      const link = wrapper.querySelector(this.linkSelector);
      if (link) {
        wrapper.classList.remove(this.classForReady);
        wrapper.removeEventListener('click', this._onClick);
        link.removeEventListener('focus', this._onFocus);
        link.removeEventListener('blur', this._onBlur);
      }
    });
  }

  /**
   * Wrapper area click
   * @param {Event} event Click event
   */
  _onClick(event) {
    const wrapper = event.currentTarget;
    const link = wrapper.querySelector(this.linkSelector);
    link.click();
  }

  /**
   * On link focus 
   * Adds styling class to wrapper
   * @param {Event} event Focus event
   */
  _onFocus(event) {
    const wrapper = event.currentTarget.closest('.' + this.classForReady);
    wrapper.classList.add('focused');
  }

  /**
   * On link blur
   * Removes styling class from wrapper
   * @param {Event} event Blur event
   */
  _onBlur(event) {
    const wrapper = event.currentTarget.closest('.' + this.classForReady);
    wrapper.classList.remove('focused');
  }

}